import React, { useEffect, useContext } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import CertificationTestData from './CertificationTestData';
import CertificationTestRules from './CertificationTestRules';
import CertificationTestScenario from './CertificationTestScenario';
import { Typography, Tabs, Tab, Paper, Box } from '@material-ui/core';
import { GET_OPERATION_DATA } from '../graphQL/queries';

import { DispatchContext, StateContext } from '../../App';

interface SimulationOperationPorps {
  userData: any;
}
const SimulationOperations = (props: SimulationOperationPorps) => {
  const { userData } = props;
  const [tab, setTab] = React.useState<any>('testData');
  const [getOperations, { data: simulatedService }] = useLazyQuery(GET_OPERATION_DATA, {
    variables: {
      search: ''
    },
    fetchPolicy: 'network-only'
  });

  const dispatch = React.useContext(DispatchContext);
  const state = useContext(StateContext);

  useEffect(() => {
    getOperations({ variables: { search: 'page=0&size=10' } });
    dispatch({
      type: 'userPreferences',
      data: {
        operationsGrid: {
          id: 'operationsGrid',
          rowsPerPage: 10,
          page: 0
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  interface TabPanelProps {
    children: React.ReactNode;
    value: string;
    index: string;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index } = props;

    return (
      <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
        {value === index && <Box>{children}</Box>}
      </Typography>
    );
  }

  const tabHandleChange = (e: any, tab: any) => {
    setTab(tab);
  };

  return (
    <Paper variant="outlined">
      <Tabs data-id="tabs" value={tab} onChange={tabHandleChange}>
        <Tab label="Test Data" value="testData" />
        <Tab label="Test Scenario" value="testScenario" />
        <Tab label="Test Rules" value="testRules" />
      </Tabs>
      <TabPanel value={tab} index="testData">
        <CertificationTestData id="operationsGrid" getOperations={getOperations} simulatedService={simulatedService} />
      </TabPanel>
      <TabPanel value={tab} index="testScenario">
        <CertificationTestScenario simulatedService={simulatedService} userData={userData} />
      </TabPanel>
      <TabPanel value={tab} index="testRules">
        <CertificationTestRules getOperations={getOperations} simulatedService={simulatedService} />
      </TabPanel>
    </Paper>
  );
};

export default SimulationOperations;
